import React from 'react'
import { useDataContext } from 'components/spreadsheet/contexts/data/useDataContext'
import { useColumnPositionResolver, useRangeOverlayLayout } from 'components/spreadsheet/hooks/useRangeOverlayLayout'

const SelectionRangeBorder: React.FC = () => {
  const { selectedCell, selectedCellRange, totalWidth } = useDataContext()
  const resolver = useColumnPositionResolver()

  // Translate the selection into a row+column range, or null when there's nothing to draw.
  const input = (() => {
    if (!selectedCell.rowId || selectedCell.editing) return null

    const anchorColPos = resolver.getPosition(selectedCell.columnId)
    if (anchorColPos === undefined) return null

    let endColPos = anchorColPos
    if (selectedCellRange.endColumnId) {
      const endPos = resolver.getPosition(selectedCellRange.endColumnId)
      if (endPos !== undefined) endColPos = endPos
    } else if (selectedCellRange.endColumnIndex !== -1) {
      endColPos = selectedCellRange.endColumnIndex
    }

    const endRowIndex = selectedCellRange.endRowIndex !== -1 ? selectedCellRange.endRowIndex : selectedCell.rowNumber

    return {
      minColPos: Math.min(anchorColPos, endColPos),
      maxColPos: Math.max(anchorColPos, endColPos),
      minRowIndex: Math.min(selectedCell.rowNumber, endRowIndex),
      maxRowIndex: Math.max(selectedCell.rowNumber, endRowIndex)
    }
  })()

  const layout = useRangeOverlayLayout(input)
  if (!layout) return null

  return (
    <React.Fragment>
      {layout.nonFrozen && (
        <div
          data-testid="selection-range-border"
          className="absolute border border-blue pointer-events-none z-[2]"
          style={{
            left: `${layout.nonFrozen.left}px`,
            top: `${layout.top}px`,
            width: `${layout.nonFrozen.width}px`,
            height: `${layout.height}px`
          }}
        />
      )}
      {layout.frozen && (
        <div
          className="absolute pointer-events-none z-[4]"
          style={{
            top: `${layout.top}px`,
            left: 0,
            width: `${totalWidth}px`,
            height: `${layout.height}px`
          }}
        >
          <div
            data-testid={layout.nonFrozen ? 'selection-range-border-frozen' : 'selection-range-border'}
            className={`sticky ${
              layout.frozen.allBorders ? 'border' : 'border-t border-b border-l'
            } border-blue pointer-events-none`}
            style={{
              left: `${layout.frozen.startLeft}px`,
              width: `${layout.frozen.width}px`,
              height: '100%'
            }}
          />
        </div>
      )}
    </React.Fragment>
  )
}

export default SelectionRangeBorder
